// extracted by mini-css-extract-plugin
export default {"quote":"index_quote_Aqk77","quoteLeft":"index_quoteLeft_w1ohw","quoteRight":"index_quoteRight_ungBf","quoteText":"index_quoteText_Q689D"};